import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { Constants } from 'src/app/shared/models/constants';
import moment from 'moment';
import { Helpers } from 'src/app/helpers';
 
@Component({
    selector: 'medpt-time',
    templateUrl: './time.component.html',
    standalone: false
})
export class TimeComponent {
  @Input() field: any = {};
  @Input() form!: FormGroup;

  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  //public steps: any = { hour: 1, minute: 30 };

  constructor() { }

  onFocus(elm: TimePickerComponent) {
    if (!elm.isOpen) {
      elm.toggle(true);
    }
  }

  public setDefaultTime() {
    var val = this.form.controls[this.field.uniquename].value;
    if (Helpers.isNullOrUndefined(val) || val == '') {
      val = new Date(moment().format('DD-MMM-YYYY') + ' 08:00 AM');
      this.form.controls[this.field.uniquename].setValue(val);
    }
  }


}



